import React, { useContext, useState } from 'react'
import { Api } from '../contexts/Api';
import { Pagination,  Modal, Box, Button, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

function RecentOrders() {
    const navigate = useNavigate();
    const { orders, handleordersFill, orderPageCount } = useContext(Api);
    const [open, setOpen] = useState(false);
    const [orderToDelete, setOrderToDelete] = useState(null);

    const handleDeleteClick = (id) => {
        setOrderToDelete(id);
        setOpen(true);  // Show the modal
    };

    const handleClose = () => {
        setOpen(false); // Close the modal
    };

    const handleConfirmDelete = async () => {
        if (orderToDelete) {
            try {
                const response = await fetch('https://elnaf.fi/new/api/removeOrder.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ 'id': orderToDelete }),
                });
                const result = await response.json();
                console.log(result);
                if (result.status === 'success') {
                    alert('Order removed successfully!');
                    navigate('/');
                } else {
                    alert('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Error removing order:', error);
            }
        }
        setOpen(false); // Close the modal after confirming
    };
    return (
        <div className="card custom-card">
            <div className="card-header justify-content-between">
                <div className="card-title">
                    Recent Orders
                </div>
                <div className="d-flex flex-wrap gap-2">
                    <div>
                        <input onChange={(e) => handleordersFill('q', e.target.value)} className="form-control form-control-sm" type="text" placeholder="Search Here" aria-label=".form-control-sm example" />
                    </div>
                    {/* <div className="dropdown">
                        <a href="javascript:void(0);" className="btn btn-primary btn-sm btn-wave" data-bs-toggle="dropdown" aria-expanded="false"> Sort By<i className="ri-arrow-down-s-line align-middle ms-1 d-inline-block" />
                        </a>
                        <ul className="dropdown-menu" role="menu">
                            <li><a className="dropdown-item" href="javascript:void(0);">New</a></li>
                            <li><a className="dropdown-item" href="javascript:void(0);">Popular</a></li>
                            <li><a className="dropdown-item" href="javascript:void(0);">Relevant</a></li>
                        </ul>
                    </div> */}
                </div>
            </div>
            <div className="card-body p-0">
                <div className="table-responsive">
                    <table className="table text-nowrap">
                        <thead>
                            <tr>
                                <th scope="col">Full Name</th>
                                <th scope="col">Company</th>
                                <th scope="col">Phone</th>
                                <th scope="col">Email</th>
                                <th scope="col">Shipping</th>
                                <th scope="col">Shipping Pay</th>
                                <th scope="col">Total</th>
                                <th scope="col">Status</th>
                                <th scope="col">Order date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                orders && orders.map((order, index) =>
                                    <tr key={index}>
                                        <td>
                                            {order.name + ' ' + order.last_name}
                                        </td>
                                        <td>
                                            {order.company || 'N/A'}
                                        </td>
                                        <td>
                                            {order.phone || 'N/A'}
                                        </td>
                                        <td>
                                            {order.email || 'N/A'}
                                        </td>
                                        <td>
                                            {order.shipping || 'N/A'}
                                        </td>
                                        <td className="fw-semibold">
                                            {'€' + order.shippingPay || 'N/A'}
                                        </td>
                                        <td className="fw-semibold">
                                            {'€' + order.total || 'N/A'}
                                        </td>
                                        <td>
                                            <span className={`badge bg-${order.status == 1 ? 'success' : (order.status == 2 ? 'warning' : (order.status == 3 ? 'secondary' : 'warning'))  }-transparent`}>
                                                {order.status == 1 ? 'Approved' : (order.status == 2 ? 'Pending' : (order.status == 3 ? 'Cancelled' : 'Pending'))}
                                            </span>
                                        </td>
                                        <td>
                                            {order.order_date || 'N/A'}
                                        </td>
                                        <td>
                                            <div className="btn-list">
                                                <Link to={`/edit-order/${order.id}`} className="btn btn-icon btn-sm btn-primary-light">
                                                    <i className="ri-edit-line" />
                                                </Link>
                                                <button  onClick={() => handleDeleteClick(order.id)} className="btn btn-icon btn-sm btn-danger-light product-btn">
                                                    <i className="ri-delete-bin-line" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            }

                        </tbody>
                    </table>
                </div>
            </div>
            <div className="card-footer">
                <div className="d-flex align-items-center">
                    <div className="ms-auto">
                        <Pagination  onChange={(event, value) => handleordersFill('page', value)}  count={orderPageCount} variant="outlined" shape="rounded" />
                    </div>
                </div>
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Are you sure you want to delete this order?
                    </Typography>
                    <div className="mt-3">
                        <Button onClick={handleClose} color="secondary" sx={{ mr: 2 }}>
                            Cancel
                        </Button>
                        <Button onClick={handleConfirmDelete} color="primary">
                            OK
                        </Button>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export default RecentOrders